import React, { useState } from 'react'
import ProductItem from '../../components/Product/ProductItem';
import Next from '-!svg-react-loader!../../assets/images/slide-arrow-next.svg';
import Prev from '-!svg-react-loader!../../assets/images/slide-arrow-prev.svg';
import { breakpoints } from '../../utils/helpers';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const ProductCarousel = ({ title = "", align = "left", products, className = '', showQuick }) => {
  const [swiper, setSwiper] = useState(null);
  if (!products?.length) { return null }

  return (
    <section className={`Product__carousel ${className}`}>
      <div className="Container">
        <h2 style={{ textAlign: align }}>{title}</h2>

        <div className="Product__carousel__wrap">
          <button
            className='Nav__button next'
            aria-label='next'
            onClick={() => swiper.slideNext()}
          >
            <Next />
          </button>
          <button
            className='Nav__button prev'
            aria-label='prev'
            onClick={() => swiper.slidePrev()}
          >
            <Prev />
          </button>
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            pagination={false}
            // loop  # Disabled beacuse staging is ridiculous. I couldn't find a solution
            slidesPerView={1}
            preloadimages="false"
            lazy="true"
            onSwiper={setSwiper}
            navigation={{
              nextEl: `${className ? '.' + className + ' ' : ''}.Nav__button.next`,
              prevEl: `${className ? '.' + className + ' ' : ''}.Nav__button.prev`,
            }}
            breakpoints={{
              [breakpoints.sm]: {
                slidesPerView: 3,
              },
              [breakpoints.md]: {
                slidesPerView: 4,
              },
              [breakpoints.lg]: {
                slidesPerView: 5,
              },
              [breakpoints.xxl]: {
                slidesPerView: 5,
              },
            }}
          >
            {products.map((item, index) => (
              <SwiperSlide key={index} className="Slide">
                <ProductItem data={item} quickView={showQuick} />
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </section >
  )
}

export default ProductCarousel